<template>
  <div class="be-content">
    <div class="main-content container-fluid">

      <guest-visit-list :operatorId="operatorId"></guest-visit-list>

    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import GuestVisitList from "@/components/guests/GuestVisitList"
  import OperatorList from "../operators/OperatorList";

  export default {
    props: ['operatorId'],
    components: {
      OperatorList,
      GuestVisitList: GuestVisitList,
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          legalEntityForms: 'legalEntityForms',
          regions: 'regions',
          privilegeCategories: 'privilegeCategories',
          operators: 'operators'
        }
      )
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/guests/App.vue